import React, {useState} from 'react';
import useAxiosIntercept from "../../../hooks/useAxiosIntercept";

function SearchUserExistence(props) {
    const [searchValue, setSearchValue] = useState(props.PhoneNumber == '' || props.PhoneNumber == null ? '' : props.PhoneNumber);
    const [message, setMessage] = useState('');
    const axiosPrivate = useAxiosIntercept();
    const [userFound, setUserFound] = useState(false);

    const getUsers = async () => {
        let URL = process.env.REACT_APP_USER_INFO_URL + '&user_type='+ "C" + '&search_by=phone&search_keyword=' + searchValue;
        try {
            setUserFound(false);
            const response = await axiosPrivate.get(URL);
            if(response?.status == 200){
                if(response?.data?.status == 200){
                    if(response?.data?.response?.data?.user_info){
                        props.setUserPersonalDetails(response?.data?.response?.data?.user_info, searchValue);

                        if(response?.data?.response?.data?.total_records != 0 )
                            setUserFound(true);
                            localStorage.removeItem("userData");
                    }
                }
                else{
                    if(response?.data?.response?.errors){
                        console.log(response?.data?.response?.errors[0].message);
                    }
                }
            }
            else{
                console.log(response?.message);
            }
            // setUsers(response?.data?.response?.data?.user_info);
            // setTotalRecords(response?.data?.response?.data?.total_records);
        } catch (err) {
            console.log(err);
        }
    };


    const validatePhone = () =>{
        let input = searchValue;
        const phoneNumberRegex = /^\d{8}(\d{2})?$/;
        if (!phoneNumberRegex.test(input)) {
            setSearchValue('');
            setMessage('Phone number invalid');
            setTimeout(()=>{
                setMessage('');
            },3000)
            return false;
        }
        return true;
    }
    function handlePhoneChange(event) {
        const inputValue = event.target.value;
        const numbersOnly = inputValue.replace(/[^0-9]/g, ''); // remove non-numeric characters
        const truncated = numbersOnly.slice(0, 10); // truncate to at most 10 digits
        setSearchValue(truncated);
    }
    const checkUserExistence = (e) =>{
        e.preventDefault();
        if(validatePhone()){
            setMessage("");
            getUsers();
        }
    }
    return (
        <>
            <div className="customerSearch">
                <h5 className="mb-8">Customer mobile number</h5>
                <div className="searchPanel">
                    <div className="searchBar">
                        <i className="material-symbols-rounded mt-m grey">search</i>
                        <input
                            type="tel"
                            name="phone_number"
                            required
                            maxLength='10'
                            minLength='8'
                            pattern="\d*"
                            value={searchValue}
                            autoComplete="nope"
                            onChange={handlePhoneChange}
                            placeholder="Enter Customer Mobile Number"
                        />
                    </div>
                    <a href="void(0)" onClick={checkUserExistence} className="btn prim">
                        Search
                    </a>
                </div>
                <span style={{color:"red"}}>
                    {message}
                </span>
                {props.step == 1 && (!userFound ?
                    <div className="findMsg mt-24">
                        <i className="material-symbols-rounded grey mt-m">person_off</i>
                        <p>No existing customer found with this number</p>
                    </div>
                    :
                    <div className="findMsg mt-24 success">
                        <i className="material-symbols-rounded grey mt-m">verified_user</i>
                        <p>Existing customer found with this number</p>
                    </div>)
                }
            </div>

            {/*<div className="customerSearch">*/}
            {/*    <label>Customer Mobile Number</label>*/}
            {/*    <span>*/}
            {/*        <input*/}
            {/*            type="tel"*/}
            {/*            name="phone_number"*/}
            {/*            required*/}
            {/*            maxLength='10'*/}
            {/*            minLength='10'*/}
            {/*            pattern="\d*"*/}
            {/*            value={searchValue}*/}
            {/*            autoComplete="nope"*/}
            {/*            onChange={handlePhoneChange}*/}
            {/*            placeholder="Enter Customer Mobile Number"*/}
            {/*        />*/}
            {/*    </span>*/}
            {/*</div>*/}

            {/*<div style={{color: "red"}}>{message}</div>*/}

            {/*<div className="actionButtons mt-24">*/}
            {/*    <span onClick={checkUserExistence}>*/}
            {/*        <a href={void(0)} className="btn prim">*/}
            {/*            Search*/}
            {/*        </a>*/}
            {/*    </span>*/}
            {/*</div>*/}
            {/*{props.step == 1 && (!userFound ?*/}
            {/*    <div className="findMsg mt-24">*/}
            {/*        <i className="material-symbols-rounded grey mt-m">person_off</i>*/}
            {/*        <p>No existing customer found with this number</p>*/}
            {/*    </div>*/}
            {/*    :*/}
            {/*    <div className="findMsg mt-24 success">*/}
            {/*        <i className="material-symbols-rounded grey mt-m">verified_user</i>*/}
            {/*        <p>Existing customer found with this number</p>*/}
            {/*    </div>)*/}
            {/*}*/}
        </>
    );
}

export default SearchUserExistence;